import React from "react";
import "./CertificateCorporateList.scss";
import CertificateCorporateList from "../../features/CertificateCorporateList/CertificateCorporateList";

const CertificateCorporateListPage = () => {
    return (
        <div className="analytics-page">
            <CertificateCorporateList />
        </div>
    );
};

export default CertificateCorporateListPage;
